<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">작품가치 제고</h2>
            </div>

            <div class="page-section-wrap">
                <section class="page-section">
                    <div class="mb-20 mb-md-40">
                        <h2 class="tit">작품 부가가치 서비스</h2>
                    </div>
                    <div class="my-n14 my-md-n20">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-valuations-img.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">
                                                    상태 검사 서비스
                                                    <v-divider vertical class="grey-da h-10px mx-6 my-auto mx-md-10"></v-divider>
                                                    <span class="font-weight-regular">Condition Reporting</span>
                                                </h4>
                                            </div>
                                            <div>
                                                <p class="page-text">경매출품 예정인 작품에 한하여, 처분할 소장품에 대한 상태검사를 실시합니다.</p>
                                                <ul class="letter-list mt-4 mt-md-6">
                                                    <li><em>-</em><span>출품작품이 50점 미만일 경우에는 무료로 진행되며, &lt;약식 상태보고서&gt;를 작성해 드립니다.</span></li>
                                                    <li><em>-</em><span>대출, 납세, 재산분할 등의 목적으로 정밀한 상태검사를 원하는 경우에는 유료로 진행되며, <br class="d-none d-md-block"/>기관 제출용 &lt;정식 상태보고서&gt;를 작성해 드립니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-valuations-img2.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">
                                                    목록 작성 서비스
                                                    <v-divider vertical class="grey-da h-10px mx-6 my-auto mx-md-10"></v-divider>
                                                    <span class="font-weight-regular">Cataloging</span>
                                                </h4>
                                            </div>
                                            <div>
                                                <p class="page-text">경매출품 예정인 작품에 한하여, 다음과 같은 항목으로 학술조사를 실시합니다.</p>
                                                <ul class="letter-list mt-4 mt-md-6">
                                                    <li><em>-</em><span>작가 확인, 작품명 확인, 크기 실측, 연도 체크, 작가 싸인 체크, 고리형태, 에디션 여부 등</span></li>
                                                    <li><em>-</em><span>소장품에 대한 현장 실사를 바탕으로, 경매출품 목적의 &lt;소장품 목록&gt;을 작성해 드립니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-valuations-img3.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">소장품 특별전 개최</h4>
                                            </div>
                                            <div>
                                                <div class="page-text">
                                                    <p>방대한 혹은 독특한 컬렉션을 형성한 소장가의 소장품을 중심으로 특별전시를 개최할 수 <br class="d-none d-md-block"/>있습니다.</p>
                                                    <p>소장가는 당사에게 기획한 특별전시를 통하여 프라이빗(비공개) 판매를 하실 수 있습니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-valuations-img4.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">
                                                    소장품 원고작성 서비스
                                                    <v-divider vertical class="grey-da h-10px mx-6 my-auto mx-md-10"></v-divider>
                                                    <span class="font-weight-regular">Description</span>
                                                </h4>
                                            </div>
                                            <div>
                                                <div class="page-text">
                                                    <p>경매출품 예정인 작품에 한하여, 개별작품에 대한 설명문 원고를 무료로 작성할 수 있습니다.</p>
                                                    <p>경매에 출품되지 않는 작품이나, 기관에서의 &lt;소장품 카드&gt; 작성을 위한 <br class="d-none d-md-block"/>&lt;작품원고 작성&gt;은 유료입니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-valuations-img5.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">가치 등급 부여</h4>
                                            </div>
                                            <div>
                                                <p class="page-text">경매출품 예정인 작품에 한하여,  개별작품에 대한 가치등급을 조사할 수 있습니다. </p>
                                                <ul class="letter-list mt-4 mt-md-6">
                                                    <li><em>-</em><span>미술사학 및 미술시장 측면에서 소장품의 가치등급을 산정해 드립니다.</span></li>
                                                    <li><em>-</em><span>가치등급은 캐터옥션의 &lt;가치등급 기준표&gt;를 적용하여 부여합니다.</span></li>
                                                    <li><em>-</em><span>가치 등급 부여를 통하여, 지속 관리할 작품과 처분할 작품을 구분할 수 있으며, 좀 더 새로운 시각에서 작품을 조명할 수 있을 것입니다. </span></li>
                                                </ul>
                                                <ul class="letter-list mt-4 mt-md-6">
                                                    <li><em>※</em><span>당사는, 대출, 납세, 재산분할, 보험가입, 기부 등의 특수 목적을 위한 가격 감정은 수행하지 않습니다.<br/>      한국화랑협회 등의 미술품 감정 전문기관에 의뢰하여 진행하시길 권해 드립니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
            </div>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
export default {
    components: {
        ClientPage,
    },
};
</script>

<style lang="scss" scoped>
</style>